import * as React from 'react'

import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import type { MessageAttachment } from '@/types/conversations'
import { resolveAttachmentMediaUrl } from '@/lib/resolveAttachmentMediaUrl'

import type { AttachmentContext } from './attachmentContext'

interface ImageAttachmentProps {
  attachment: MessageAttachment
  attachmentContext?: AttachmentContext
}

export function ImageAttachment({
  attachment,
  attachmentContext = 'assistant',
}: ImageAttachmentProps) {
  const [open, setOpen] = React.useState(false)
  const src = resolveAttachmentMediaUrl(attachment.file_url)
  const alt =
    attachmentContext === 'assistant' && attachment.ai_description?.trim()
      ? attachment.ai_description
      : attachment.caption || attachment.filename || 'Imagen'


  if (!src) {
    return null
  }

  return (
    <>
      <img
        key={src}
        src={src}
        alt={alt}
        className="max-h-72 w-full max-w-[min(100%,280px)] cursor-pointer rounded-md border object-cover"
        onClick={() => setOpen(true)}
        onError={(e) => { e.currentTarget.style.display = 'none' }}
      />
      {attachment.caption && (
        <p className="max-w-[280px] text-xs text-muted-foreground">{attachment.caption}</p>
      )}
      {/* Era un modal casero: `fixed inset-0`, el scroll del body bloqueado a
          mano, la tecla Escape escuchada a mano y un boton de cerrar dibujado
          con su propio circulo. El estandar lo prohibe, y Radix trae las cuatro
          cosas -incluido devolver el foco al salir-. */}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-[95vw] border-0 bg-transparent p-0 shadow-none sm:max-w-[90vw]">
          <DialogTitle className="sr-only">{alt}</DialogTitle>
          <img
            src={src}
            alt={alt}
            className="max-h-[90vh] w-full rounded-md border object-contain"
            onError={(e) => { e.currentTarget.style.display = 'none' }}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
